<script>
import CommonMixin from '../CommonMixin';
import LanguageButtonConnected from '@/launcher/components/connected/ui/LanguageButtonConnected.vue';

export default {
  mixins: [CommonMixin],
  name: 'LauncherOutlet',
  components: {
    LanguageButtonConnected,
  },
  computed: {
    shouldDisplayFilterBox () {
      return !this.$store.getters.safetyMode && !['games-show', 'games-search'].includes(this.$route.meta.realName);
    },
  },
};
</script>

<template lang="pug">
div.launcher-outlet
  div.launcherwrapper.inline-flex(v-if="!$store.getters.hasExpired" :style="{ opacity: !$store.state.launcher.loadings.launchingGame ? 1 : 0 }")
    PanelContainer.adbox.panel.shrink-0(id="v2-advertisementpanel-left" usage="launcher" style="width: 300px" v-if="!$permissions['content-only'] && $store.getters.bannersLeft && $store.getters.bannersLeft.length")
      AdBoxConnected.h-100(side="left")
    template(v-if="$store.getters.canSeeGames")
      PanelContainer.filterbox.panel.shrink-0(id="filterpanel" usage="launcher" style="width: 240px; margin-right: 40px;")
        .fullpanel.h-100
          FilterBoxConnected.w-100.h-100(v-if="shouldDisplayFilterBox")
      PanelContainer.mainbox.panel.shrink-0(id="mainpanel" usage="launcher" title="" style="width: 740px;margin-right: 100px;" :style="$permissions['content-only'] && { width: `${740 + 71}px`, paddingRight: '71px'}")
        LanguageButtonConnected.languagebtn.absolute.right-0.z-5(v-if="$permissions['content-only']")
        .fullpanel.h-100
          keep-alive(:include="['GamesSearchRoute', 'GamesIndexRoute']")
            router-view
    PanelContainer.adbox.panel.shrink-0(id="advertisementpanel-right" usage="launcher" style="width: 300px;" v-if="!$permissions['content-only'] && $store.getters.bannersRight && $store.getters.bannersRight.length")
      AdBoxConnected.h-100(side="right")
    template(v-if="$store.state.launcher.appState.overlay")
      PanelContainer.panel.mr4(id="statuspanel" style="width: 240px;")
        StatusBoxConnected.h-100.w-100(:launcher="true")
      PanelContainer.panel(id="controlspanel" style="width: 500px;")
        ControlsBoxLauncherConnected.h-100
  PanelContainer.settingsbox.panel.shrink-0.w-100(v-if="!$permissions['content-only']" id="settingspanel" :usage="'auto'" :duplicatePanel="true" style="height: 20rem" :noTitle="true")
    .flex.justify-center.items-center.h-100
      SettingsBoxConnected

</template>

<style scoped>
.launcher-outlet {
  display: table;
  & .launcherwrapper {
    transition: opacity 0.3s ease-in-out;
  }
  & .notificationpanel {
    height: 8rem;
  }
  & .languagebtn {
    transform: translateX(100%);
  }
}
</style>
